import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-send-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.08326 11.2501L17.8333 2.50005M9.18958 11.5234L11.3797 17.1551C11.5726 17.6512 11.6691 17.8993 11.8081 17.9717C11.9286 18.0345 12.0721 18.0346 12.1927 17.9719C12.3318 17.8997 12.4285 17.6517 12.6221 17.1558L18.114 3.08272C18.2887 2.63507 18.376 2.41124 18.3283 2.26822C18.2868 2.14401 18.1893 2.04654 18.0651 2.00504C17.9221 1.95726 17.6982 2.04461 17.2506 2.2193L3.17747 7.71125C2.68158 7.90477 2.43363 8.00153 2.36137 8.14062C2.29873 8.26119 2.29882 8.40474 2.3616 8.52523C2.43402 8.66424 2.68208 8.7607 3.1782 8.95364L8.80987 11.1437C8.91058 11.1829 8.96093 11.2025 9.00333 11.2327C9.04092 11.2595 9.07378 11.2924 9.10059 11.33C9.13083 11.3724 9.15041 11.4227 9.18958 11.5234Z"
      [attr.stroke]="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class SendIcon extends BaseIconComponent {}
